window.addEventListener('load', function () {
    if ($('#body3 .shareColContainer').length && $('#grid .shareColContainer').length && !$('#s-accordion').length) {
        $('#grid .shareColContainer').css("display", "none");
    }
});